export const separators = {
  LOCATION_DATA_FIELD_SEPARATOR: ",",
  LOCATION_DATA_KEY_VALUE_SEPARATOR: "=",
};
